export default __webpack_public_path__ + "static/media/login_logo.b5f6aa79.png";